import { apiFetch } from '..'

/**
 * インセンティブ一覧レスポンス型
 */
export interface OpportunityIncentive {
  id: number
  opportunity_id: number
  salesforce_project_name: string | null
  sales_id: string | null
  sales_on: string
  sales_amount: number | null
  sales_stage_id: number | null
  sales_stage: string | null
  previously_closed_sales_stage_id: number | null
  previously_closed_sales_stage: string | null
  incentive_coefficient: number | null
  incentive_amount: number | null
  period: string
  notes: string | null
  updated_at: string
  created_at: string
}

export interface OpportunityIncentivesResponse {
  total: number
  incentives: OpportunityIncentive[]
}

/**
 * インセンティブ確認履歴レスポンス型
 */
export interface OpportunityIncentiveAccept {
  id: number
  period: string
  updated_at: string
  created_at: string
}

export interface OpportunityIncentiveAcceptsResponse {
  total: number
  accepts: OpportunityIncentiveAccept[]
}

/**
 * メンバーのインセンティブ一覧取得API
 *
 * @param memberId - メンバーID
 * @param params - クエリパラメータ
 * @returns インセンティブ一覧レスポンス
 */
export async function getMemberOpportunityIncentives(
  memberId: number,
  params?: {
    period?: string
    offset?: number
    limit?: number
  },
): Promise<OpportunityIncentivesResponse> {
  const queryParams = new URLSearchParams()
  if (params?.period) {
    queryParams.append('period', params.period)
  }
  if (params?.offset !== undefined) {
    queryParams.append('offset', params.offset.toString())
  }
  if (params?.limit !== undefined) {
    queryParams.append('limit', params.limit.toString())
  }

  const queryString = queryParams.toString()
  const url = `/api/member/${memberId}/opportunity-incentives${queryString ? `?${queryString}` : ''}`

  return apiFetch(url, { method: 'GET' })
}

/**
 * メンバーのインセンティブ確認履歴取得API
 *
 * @param memberId - メンバーID
 * @returns インセンティブ確認履歴レスポンス
 */
export async function getMemberOpportunityIncentiveAccepts(
  memberId: number,
): Promise<OpportunityIncentiveAcceptsResponse> {
  const url = `/api/member/${memberId}/opportunity-incentive/accepts`

  return apiFetch(url, { method: 'GET' })
}

/**
 * インセンティブ確認登録API
 *
 * @param memberId - メンバーID
 * @param period - 支払対象期間
 * @returns 作成された確認レコード
 */
export async function acceptOpportunityIncentive(
  memberId: number,
  period: string,
): Promise<OpportunityIncentiveAccept> {
  const url = `/api/member/${memberId}/opportunity-incentive/accept`

  return apiFetch(url, {
    method: 'POST',
    body: JSON.stringify({ period }),
  })
}
